import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces the window to jump to the top every time the route changes.
 * Drop this component once, inside your router hierarchy.
 */
export default function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use 'instant' so it just snaps; switch to 'smooth' if you want the glide effect
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return <div className="scroll-smooth"></div>; // nothing to render
}
